import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

const COLORES = {
  esmeralda: 'bg-marca-500 ring-marca-500/20',
  indigo: 'bg-indigo-500 ring-indigo-500/20',
  ambar: 'bg-amber-500 ring-amber-500/20',
  violeta: 'bg-violet-500 ring-violet-500/20',
  azul: 'bg-blue-500 ring-blue-500/20',
  pizarra: 'bg-armazon-700 ring-armazon-500/20',
} as const;

export type ColorDeIcono = keyof typeof COLORES;

interface Props {
  icono: LucideIcon;
  color?: ColorDeIcono;
  titulo: string;
  subtitulo: string;
  acciones?: ReactNode;
}

export function EncabezadoDePagina({
  icono: Icono,
  color = 'esmeralda',
  titulo,
  subtitulo,
  acciones,
}: Props) {
  return (
    <header className="mb-8 flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
      <div className="flex items-center gap-4">
        <span
          className={`grid size-12 shrink-0 place-items-center rounded-2xl text-white shadow-sm ring-4 ${COLORES[color]}`}
        >
          <Icono className="size-[22px]" aria-hidden />
        </span>
        <div className="min-w-0">

          <h1 className="text-2xl font-bold uppercase tracking-tight text-armazon-900">{titulo}</h1>
          <p className="mt-0.5 text-sm uppercase tracking-wide text-armazon-500">{subtitulo}</p>
        </div>
      </div>

      {acciones && <div className="flex shrink-0 items-center gap-2">{acciones}</div>}
    </header>
  );
}
